import { Object, Static, Number, String, Boolean } from 'runtypes';
import { UserAccountStatusRecord } from './user';

export const mailerRoutes = () => ({
  alertUserStatusEmail: {
    method: 'patch',
    path: '/user/alert-user-status-email',
    requestBody: UserStatusEmailRequestRecord,
    responseData: SentEmailResponseRecord,
  },
  dailyStaffEmail: {
    method: 'patch',
    path: '/mailer/daily-staff-email',
    requestBody: DailyStaffEmailRequestRecord,
    responseData: SentEmailResponseRecord,
  },
});

const UserStatusEmailRequestRecord = Object({
  userId: Number,
  status: UserAccountStatusRecord,
  subject: String,
  emailContent: String,
  secret: String,
});
const DailyStaffEmailRequestRecord = Object({
  secret: String,
});

const SentEmailResponseRecord = Object({
  sent: Boolean,
});

export type StandardSentEmailResponse = Static<typeof SentEmailResponseRecord>;
